import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { concatAndDeDuplicateObjects } from '@/lib/utils';

interface TaskItem {
  id: string;
  started_at?: string;
  completed_at?: string;
  [key: string]: any;
}

interface TasksState {
  items: TaskItem[];
  loading: boolean;
  error: string | null;
}

const initialState: TasksState = {
  items: [],
  loading: false,
  error: null,
};

const tasksSlice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {
    // Action creators for Redux Offline
    updateTask: (state, action: PayloadAction<{
      task: TaskItem;
      started_at?: string;
      completed_at?: string;
    }>) => {
      const index = state.items.findIndex(item => item.id === action.payload.task.id);
      if (index !== -1) {
        const updates: Partial<TaskItem> = {};
        
        if (typeof action.payload.started_at !== 'undefined') {
          updates.started_at = action.payload.started_at;
        }
        
        if (typeof action.payload.completed_at !== 'undefined') {
          updates.completed_at = action.payload.completed_at;
        }
        
        state.items[index] = { ...state.items[index], ...updates };
      }
    },
    updateTaskCommit: (state) => {
      // Handle success if needed
    },
    updateTaskFailed: (state, action: PayloadAction<string, string, {
      originalPayload: {
        task: TaskItem;
        started_at?: string;
        completed_at?: string;
      };
    }>) => {
      state.error = action.payload;
      // Restore original task data on failure
      if (action.meta?.originalPayload) {
        const index = state.items.findIndex(item => item.id === action.meta.originalPayload.task.id);
        if (index !== -1) {
          state.items[index] = action.meta.originalPayload.task;
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase('GET_BOOKINGS_COMMIT', (state, action: PayloadAction<{
      tasks?: TaskItem[];
      page?: number;
    }>) => {
      if (action.payload.page) {
        if (action.payload.page && action.payload.tasks && action.payload.tasks.length > 0) {
          state.items = concatAndDeDuplicateObjects('id', state.items, action.payload.tasks);
        }
      } else {
        state.items = action.payload.tasks || [];
      }
    });
  },
});

export const {
  updateTask,
  updateTaskCommit,
  updateTaskFailed,
} = tasksSlice.actions;

export default tasksSlice.reducer;

// Selectors
export const selectTasksByJobId = (state: any, jobId: string) => {
  return state.tasks.items.filter((task: TaskItem) => task.job_id === jobId);
};